import { CommonAPIService } from 'src/servicehandlers/CommonHandler';

export class WorkSchedulesAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getAllWorkSchedules(router){
    const url = `/api/workSchedules`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getAllWorkSchedulesForFlightSchool(schoolId, router){
    const url = `/api/workSchedules/school/${schoolId}`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getWorkScheduleById(id, router) {
    const url = `/api/workSchedules/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  createWorkSchedule(params, router) {
    const url = `/api/workSchedules`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateWorkSchedule(id, params, router) {
    const url = `/api/workSchedules/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteWorkSchedule(id, router) {
    const url = `/api/workSchedules/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

}
export default WorkSchedulesAPIService;
